import messageChannelService from '../message-channel.service'
import { withRetry } from '../../../utilities/pinpad-v2/retry'
import { logInfo, logError } from '../../../utilities/pinpad-v2/logger'

class CardService {
  formatAmount(amount) {
    const numeric = Number.parseFloat(amount)
    if (Number.isNaN(numeric)) {
      const error = new Error(`Invalid amount: ${amount}`)
      error.code = 'INVALID_AMOUNT_FORMAT'
      throw error
    }
    return numeric.toFixed(2)
  }

  extractBIN(maskPan) {
    if (!maskPan || typeof maskPan !== 'string' || maskPan.length < 6) {
      const error = new Error('Invalid maskPan: must contain at least 6 chars')
      error.code = 'INVALID_MASK_PAN'
      throw error
    }
    return maskPan.substring(0, 6)
  }

  async readCard(params) {
    const payload = {
      Ambiente: params?.Ambiente,
      Currency: params?.Currency,
      CurrencyCode: params?.CurrencyCode,
      Amount: this.formatAmount(params?.Amount),
      TimeOutPinPad: params?.TimeOutPinPad || '60',
      MarcaTerminal: params?.MarcaTerminal,
      ModeloTerminal: params?.ModeloTerminal,
      Reference: params?.Reference,
      ...(params?.tipAmount ? { tipAmount: this.formatAmount(params.tipAmount) } : {})
    }

    const required = ['Ambiente', 'Currency', 'CurrencyCode', 'Amount', 'MarcaTerminal', 'ModeloTerminal', 'Reference']
    const missing = required.filter((field) => !payload[field])
    if (missing.length) {
      const error = new Error(`Missing required parameters: ${missing.join(', ')}`)
      error.code = 'INVALID_PARAMETERS'
      throw error
    }

    const readCardFn = async () => {
      logInfo('readCard payload prepared', {
        payload,
      })

      const response = await messageChannelService.sendMessage('readCard', payload, 60000)

      logInfo('readCard response received', {
        reference: payload.Reference,
        response,
      })

      if (!response || response.RESPUESTA === 'error') {
        const error = new Error(response?.ERROR || 'readCard failed')
        error.code = response?.codError || 'READ_CARD_ERROR'
        throw error
      }
      if (!response.maskPan) {
        const error = new Error('readCard response missing maskPan')
        error.code = 'MISSING_CARD_DATA'
        throw error
      }
      return response
    }

    try {
      logInfo('Starting readCard operation', { reference: payload.Reference, amount: payload.Amount })
      return await withRetry(readCardFn, { operation: 'READ_CARD' })
    } catch (error) {
      logError('readCard failed', error, { reference: payload.Reference })
      throw error
    }
  }
}

const cardService = new CardService()

export default cardService
